import { FC } from 'react';
import { Button } from 'react-daisyui';
import { useNavigate } from 'react-router-dom';
import Routes from '@/router/Routes.ts';

type IntroCallConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  carerName: string;
};

const IntroCallConfirmationModal: FC<IntroCallConfirmationModalProps> = ({ 
  isOpen, 
  onClose, 
  carerName 
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
    navigate(Routes.INTRO_CALLS);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
        {/* Confirmation */}
        <div className="w-full p-8 flex flex-col justify-center text-center">
          <h2 className="text-xl font-bold mb-4">Your intro call request has been sent!</h2>
          
          <p className="text-gray-600 text-sm mb-6">
            We've shared your request with your Carer {carerName} who'll review the details and respond soon.
          </p>

          <Button
            onClick={handleClose}
            className="w-full bg-black text-white border-none hover:opacity-90 rounded-lg py-3"
          >
            Go to Intro Calls
          </Button>
        </div>
      </div>
    </div>
  );
};

export default IntroCallConfirmationModal;
